import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { Observable, of, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CoursesService } from '../services/courses.service';

@Injectable({
  providedIn: 'root'
})
export class UserCoursesResolver implements Resolve<any> {
  constructor(private coursesService: CoursesService, private auth: AuthService, private router: Router, private flashMessage: FlashMessagesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return of(this.coursesService).pipe(
      switchMap(() => {
        // reject super admins to visit pages on user courses, they follow different workflow not supported by super admins
        if (this.auth.isSuperAdmin) {
          this.showError('Page is not available for preview by super admin.');
          console.log(route);
          this.router.navigate(['/admin/admin-courses']);
          return EMPTY;
        }

        // check if already loaded for this user
        const loaded = this.coursesService.userCourses ? this.coursesService.courses.length > 0 : false;
        const forCurrentUser = this.auth.user?.id === this.coursesService.rentWiseUserID;

        let cachedData = null as any;

        if (loaded && forCurrentUser) {
          cachedData = of({
            rentWiseAgency: this.coursesService.rentWiseAgency,
            courses:        this.coursesService.courses,
          });
        }

        const observable = cachedData || this.coursesService.getUserCourses({ getmodules: true });

        // Request courses from the database for this User
        return observable.pipe(
          switchMap((courses: any) => {
            this.coursesService.userCourses = true;
            this.coursesService.rentWiseAgency = courses.rentWiseAgency;
            this.coursesService.rentWiseUserID = this.auth.user?.id || '';
            this.coursesService.courses = courses.courses;

            this.coursesService.reloadCurrentCourse();

            if (route.data.course) {
              this.coursesService.setCurrentCourseBy(route.data.course);
            }

            if (route.params.courseid) {
              this.coursesService.setCurrentCourseBy(route.params.courseid);
            }

            return of(courses);
          })
        );
      })
    );
  }

  private showError(message: string) {
    console.warn(message);
    this.flashMessage.show(message, {
      cssClass: 'alert-danger',
      timeout: 3000
    });
  }
}
